import React from 'react';
import SEO from '../Components/SEO';

const indexes = [
    { name: 'Crossref', desc: 'DOI registration and metadata distribution for all accepted articles.', status: 'In Progress' },
    { name: 'Google Scholar', desc: 'Scholarly search discovery via structured metadata and full‑text indexing.', status: 'In Progress' },
    { name: 'Index Copernicus', desc: 'Journal profile and indexing services supporting broader visibility.', status: 'In Progress' },
    { name: 'NASA ADS', desc: 'Astrophysics Data System coverage for applicable domains and citations.', status: 'In Progress' },
    { name: 'ANED', desc: 'American National Engineering Database listing to broaden engineering reach.', status: 'In Progress' },
];

export default function AbstractingandIndexing() {
    return (
        <div style={{ padding: '40px 20px', minHeight: '70vh' }}>
            <SEO title="Abstracting &amp; Indexing – ITME" url="/abstracting-indexing" description="Indexing and abstracting partners for the ITME journal, including Crossref, Google Scholar, Index Copernicus, NASA ADS, and ANED." />
            <div style={{ maxWidth: 1040, margin: '0 auto', fontFamily: 'Arial, Helvetica, sans-serif' }}>
                <header style={{ textAlign: 'left', margin: '8px 0 28px' }}>
                    <h1 style={{ margin: 0, color: '#0062a1', textAlign: 'left' }}>Abstracting &amp; Indexing</h1>
                </header>

                <section style={{ display: 'grid', gap: 18, gridTemplateColumns: 'repeat(auto-fit,minmax(260px,1fr))' }}>
                    {indexes.map(x => (
                        <article key={x.name} style={cardStyle}>
                            <h3 style={cardTitleStyle}>{x.name}</h3>
                            <p style={cardTextStyle}>{x.desc}</p>
                            <div style={{ marginTop: 'auto', display:'flex', alignItems:'center', gap:7 }}>
                                <span style={{ fontSize: 12, color: '#5a6b70' }}>Status:</span>
                                <span style={{ fontSize: 12, fontWeight: 700, color: '#00538a' }}>{x.status}</span>
                            </div>
                        </article>
                    ))}
                </section>

                <aside style={{ marginTop: 24, color: '#5a6b70', fontSize: 13 }}>
                    Note: Additional databases may be added over time.
                </aside>
            </div>
        </div>
    );
}

const cardStyle = {
    background: '#ffffff',
    border: '1px solid #e0e4e6',
    borderRadius: 6,
    padding: '18px 16px',
    position: 'relative',
    minHeight: 140,
    display: 'flex',
    flexDirection: 'column'
};

const cardTitleStyle = {
    fontSize: '1rem',
    margin: '0 0 6px',
    lineHeight: 1.35,
    color: '#0062a1',
    fontWeight: 700
};

const cardTextStyle = {
    fontSize: '.88rem',
    margin: 0,
    color: '#333',
    lineHeight: 1.5
};
